export default __webpack_public_path__ + "static/media/icon-gift.611b8a07.svg";